module.exports = __webpack_public_path__ + "img/1.bfac09cf.png";